// extracted by mini-css-extract-plugin
export var buttonContainer = "index-module--buttonContainer--ZcyAN";
export var card = "index-module--card--zsyTm";
export var cardImg = "index-module--cardImg--VG1OT";
export var container = "index-module--container--EQyYK";
export var description = "index-module--description--B2mGs";
export var fullwidthWrapper = "index-module--fullwidthWrapper--ezBvB";
export var imageBox = "index-module--imageBox--PLxZN";
export var imageCard = "index-module--imageCard--qdhd0";
export var imageCards = "index-module--imageCards--ji6pl";
export var innerContainer = "index-module--innerContainer--oD-vt";
export var joinUsButton = "index-module--joinUsButton--p2BGI";
export var label = "index-module--label--3sAdq";
export var textCard = "index-module--textCard--qeDMV";
export var textCards = "index-module--textCards--i2q4N";
export var textOnlyCard = "index-module--textOnlyCard--J1yHK";
export var title = "index-module--title--YEktm";